import { useEffect } from 'react'

import styled from 'styled-components'

import { FlexContainer, HeadTag } from '@/components'
import { LpHeader } from '@/components/lpHeader'
import { FooterLandingPage } from '@/containers'
import { ThankYouContainer } from '@/containers/thankYouContainer'

const LandingPageContainer = styled(FlexContainer)`
  max-width: 100%;
  padding: 197px 16px;

  @media (max-width: 1100px) {
    padding: 150px 16px;
  }
  @media (max-width: 533px) {
    padding: 150px 16px 129px;
  }
`

const ThankYouPage: React.FC = () => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <>
      <HeadTag
        title="nata.house"
        description=""
        languageOptions={['en']}
        path="/thank-you"
      />
      <LpHeader redirectUrl="https://natahouse.com" hasTranslation={false} />
      <LandingPageContainer>
        <ThankYouContainer />
      </LandingPageContainer>
      <FooterLandingPage />
    </>
  )
}

export default ThankYouPage
